var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-background white-wrapper mt-3",on:{"click":_vm.showHoroscope}},[_c('div',{staticClass:"title"},[_vm._v(" Гороскоп"),_c('br'),_vm._v(" на "+_vm._s(_vm.today)+" ")]),_c('img',{attrs:{"src":require("../../assets/horoscope/sun.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }